"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = DateInput;
const react_1 = __importDefault(require("react"));
const useInputDebounce_1 = __importDefault(require("../hooks/useInputDebounce"));
const date_string_converter_1 = __importDefault(require("../utils/date-string-converter"));
const friendly_date_string_1 = __importDefault(require("../utils/friendly-date-string"));
const normalizer = date => date instanceof Date ? (0, friendly_date_string_1.default)(date) : date;
const parseDate = value => {
    if (typeof value !== 'string')
        return '';
    if (value.length === 10) {
        const date = (0, date_string_converter_1.default)(value);
        if (date && normalizer(date) === value) {
            return date;
        }
    }
    return value;
};
const handleChange = cb => ({ target: { value } }) => {
    cb(parseDate(value), normalizer);
};
function DateInput({ value, onChange, onBlur, id }) {
    const [val, debounceOnChange, flush] = (0, useInputDebounce_1.default)({ value, onChange });
    return (react_1.default.createElement("input", { value: val, id: id, onChange: handleChange(debounceOnChange), onBlur: () => {
            onBlur();
            flush();
        } }));
}
//# sourceMappingURL=Date.js.map